import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

export const BooleanListConst: IRadioButtonOption<boolean>[] = [
  {
    value: true,
    label: 'Yes',
  },
  {
    value: false,
    label: 'No',
  },
];
